/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

function InputSelectField(props) {
  const { name, label, formItemLayout, options, placeholder, handleChange} = props;
  // eslint-disable-next-line
  const [field, meta, helpers] = useField(name);
  const { t } = useTranslation();

  const { value } = meta;
  const { setValue } = helpers;

  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      help={meta.touched && meta.error}
    >
       <Select {...field} showSearch onChange={val => {
         setValue(val);
         handleChange(name, val);
        }} name={name} placeholder={placeholder} filterOption={(input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    } size="large" >
        {options.map(({ value, label }) => (
          <Option key={value} value={value}>
            {t(label)}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}

InputSelectField.defaultProps = {
  formItemLayout: {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  },
  handleChange: () => {}
};

const { shape, string, array, func } = PropTypes;

InputSelectField.propTypes = {
  name: string.isRequired,
  label: string,
  formItemLayout: shape({}),
  handleChange: func,
  options: array,
  placeholder: string
};

export default InputSelectField;
